import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const EmbeddedAdminCheckoutReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/invoicing/checkout-report', component: FuseLoadable({ loader: () => import('./ViewEmbeddedAdminCheckoutReportApp') }) }],
};

export default EmbeddedAdminCheckoutReportConfig;
